export const urls = {
  login: "login",
  logout: "logout",
  register: "register",
  refresh: "refresh",
  ManageLeadsList: "listofManageLeads",
  ManageLeadsListV2: "v2/listofManageLeads",
  leadstage: "leadStages",
  leadsource: "leadSources",
  leadowner: "leadOwner",
  leadEkycStages: "ekycstages",
  audit: "leadsAudit",
  leadHistory: "leadsActivityHistory",
  leadDetails: "leadDetailById",
  addLead: "leadsAdd",
  callLead: "leadsCall",
  entityDetails: "leadsEntityDetails",
  importLead: "leadsImport",
  importLeadByOperation: "leadsImportByOperation",
  exportlead: "leadsExport",
  addUser: "userAdd",
  userentitydetails: "userEntityDetails",
  ManageUserList: "listofManageUser",
  sectionDetails: "leadsSectionDetails",
  reqHistory: "requestHistory",
  editLead: "leadsEdit",
  deleteLead: "leadsDelete",
  userrole: "userRole",
  userType: "userType",
  userstatus: "userStatus",
  userExport: "usersExport",
  userImport: "usersImport",
  userDelete: "userDelete",
  userPassword: "changePassword",
  userForgotPassword: "forgotPassword",
  userResetPassword: "resetPassword",
  validateForgotPassLink: "verifyForgotPassLink",
  leadNoteDetail: "leadsNoteDetail",
  editLeadBulk: "leadsEditBulk",
  leadEntityCondition: "leadsEntityConditionsDetails",
  userRoleMaster: "userRoleMaster",
  userReportingList: "userReportingList",
  callDisosition: "DispositionMasterList",
  callsubDisposition: "SubDispositionList",
  rolesList: "roles",
  rolePermissions: "rolePermissions",
  allRolePermissions: "allRolePermissions",
  updateRolePermission: "updatePermission",
  entityPermissions: "entityPermissions",
  updateRoleEntityPermission: "updateEntityPermission",
  editUserBulk: "usersEditBulk",
  leadLovDropDown: "leadLovValues",
  csvFileDownload: "downloadCsv",
  dashboardAcquisitionTilesCount: "leadDashboardAcquisitionTilesCount",
  graphReportLeadSource: "graphReportLeadSources",
  graphReportLeadStage: "graphReportLeadStages",
  leadPermissionSection: "leadsSectionDetailsByRole",
  manageUsersEntityEdit: "userSectionDetailsByRole",
  graphReportLeadPaymentInsight: "graphReportLeadPaymentInsight",
  graphReportLeadConversionPerDay: "leadConversionPerDayGraph",
  smartViewAgentReferralLead: "listofAgentReferralLeads",
  smartViewUnAttemptedLead: "getUnAttemptedLeads",
  smartViewMarginNotAddedLead: "listofMarginNotAddedLeads",
  smartViewFnONotActivatedLead: "listofFnONotActivatedLeads",
  smartViewTodayCallBackLead: "listoftodaycallbacksLeads",
  smartTabsLeadsV2: "getSmartTabsLeads",
  uploadCsv: "uploadCsv",
  downloadZip: "downloadZip",
  smartViewsExport: "smartViewsExport",
  whatsappTemplates: "whatsappTemplates",
  whatsappParams: "whatsappParams",
  whatsappMessage: "sendWhatsappMessage",
  smsTemplates: "smsTemplates",
  smsParams: "smsParams",
  smsMessage: "sendSmsMessage",
  emailTemplates: "emailTemplates",
  emailParams: "emailParams",
  emailMessage: "sendEmailMessage",
  userLov: "userLovValues",
  genOTP: "genOTP",
  verifyOTP: "verifyOTP",
  getReport: "getReport",
  getautomationwhatsappstate: "getautomationwhatsappstate",
  getleadentitydetailsdisplayname: "getleadentitydetailsdisplayname",
  setwhatsappautomationtemplates: "setwhatsappautomationtemplates",
  multieditlead: "multieditlead",
  userDetails: "getuserdetails",
  usermultifieldedit: "usermultifieldedit",
  getLeadActivityType: "getleadactivitytype",
  getLeadActivityOwner: "getleadactivityowner",
  getLeadActivityTransaction: "getleadactivitytransaction",
  getLeadActivityList: "getleadactivitylist",
  leadSourceMedium: "sourcemedium",
  getreportingusers: "getreportingusers",
  getDashboardAccess: "dashboardSectionDetailsByRole",
  dispositionPopupList: "dispositionPopupList",
  clickToCall: "clickToCall",
  getautomationrequesthistory: "getautomationrequesthistory",
  psmlcdata: "psmlcdata",
  psmludata: "psmludata",
  psmdelete: "psmdelete",
  psmdropdowndata: "psmdropdowndata",
  psmedit: "psmedit",
  psmadd: "psmadd",
  exportLeadWrapper: "leadsExportWrapper",
  getwhitelistedips: "getwhitelistedips",
  addwhitelistedip: "addwhitelistedip",
  removewhitelistedip: "removewhitelistedip",
  wtemplatemaster: "wtemplatemaster",
  getwhatsapptemplategupshupoptions: "getwhatsapptemplategupshupoptions",
  getwhatsapptemplateparameters: "getwhatsapptemplateparameters",
  redisdashboardAcquisitionTilesCount: "redisdashboardAcquisitionTilesCount",
  redisgraphReportLeadSource: "redisgraphReportLeadSource",
  redisgraphReportLeadPaymentInsight: "redisgraphReportLeadPaymentInsight",
  redisgraphReportLeadConversionPerDay: "redisgraphReportLeadConversionPerDay",
  churnsaved: "churnsaved",
  churnreport: "churnreport",
  churndropdown: "churndropdown",
  churndropdowndata: "churndropdowndata",
  churnleadcount: "churnleadcount",
  churnschedulenow: "churnschedulenow",
  churnschedulelater: "churnschedulelater",
  deletechurn: "deletechurn",
  getEkycModifiedLeads: "getEkycModifiedLeads",
  getesignnaleads: "getesignnaleads",
  mediaquerydocs: "mediaquerydocs",
  deletedLeads: "deletedLeads",
  deletedLeadBy: "deletedLeads/deletedByUsers",
  smsTemplatesList : "smsTemplatesList",
  createSMSTemplate: "smsTemplate/create",
  smsProviderMaster: "smsProviderMaster",
  getLeadDistributionRatio: "getLeadDistributionRatio",
  updateLeadDistributionRatio: "updateLeadDistributionRatio",
};
